module.exports = __webpack_public_path__ + "media/bootstrap-icons/backspace-reverse-fill-1a52c3f7.svg";